/**
 * GlobalSearchBar Component:
 * A reusable component for rendering a search bar with an input field and search icon.
 * Props:
 *   - subId: ID for the field of SearchInput component.
 *   - placeholder: Placeholder text for the field of SearchInput component.
 *   - value: Value of the field of SearchInput component.
 *   - className: Additional CSS classes for styling the component.
 *   - subClassName: Additional CSS classes for styling the field of SearchInput component.
 *   - onChange: Function to handle input change event.
 */
import React from "react";
// External dependencies
import classNames from "classnames";
// Internal dependencies
import SearchInput from "../inputs/SearchInput";
import { Division } from "./GlobalSearchBar.style";
import Icon from "../Icon/Icon";

interface GlobalSearchBarProps {
  subId: string;
  placeholder: string;
  value: string;
  className?: string;
  subClassName?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const GlobalSearchBar: React.FC<GlobalSearchBarProps> = ({
  subId,
  placeholder,
  value,
  className,
  subClassName,
  onChange,
  ...props
}) => {
  // Combining default and additional classes for the Division
  const divClasses = classNames("input-group", "input-group-sm", className);
  return (
    <Division className={divClasses}>
      <SearchInput
        id={subId}
        placeholder={placeholder}
        className={subClassName}
        onChange={onChange}
        value={value}
        {...props}
      />
      <Icon name="search" className="search-font fa"></Icon>
    </Division>
  );
};

export default GlobalSearchBar;
